import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { NAV_LINKS, PRESENCE } from "./data";

const focus = [
  "Food & Beverage",
  "Natural Ingredients",
  "Premium Consumer Products",
  "Private Label",
  "International Procurement",
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A1F16] border-t border-[#BFA26F]/25 text-[#FBF9F6]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 md:py-24">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <img src="/rsc-logo.webp" alt="RSC Imports" className="h-14 w-auto bg-[#FBF9F6] p-2" data-testid="footer-logo" />
          <p className="mt-6 font-display text-2xl font-medium text-[#BFA26F] italic">
            Global Products. Regional Opportunity.
          </p>
          <p className="mt-4 text-sm font-light text-[#FBF9F6]/60 leading-relaxed max-w-sm">
            RSC Imports is an international sourcing, procurement and market-development company
            connecting global producers with high-growth consumer markets.
          </p>
          <a
            href="mailto:procurement@rscimports.com"
            data-testid="footer-email-link"
            className="mt-6 inline-flex items-center gap-3 text-sm text-[#BFA26F] hover:text-[#FBF9F6] transition-colors duration-200"
          >
            <Mail size={16} strokeWidth={1.5} /> procurement@rscimports.com
          </a>
        </div>

        <div className="lg:col-span-7">
          <p className="text-xs uppercase tracking-[0.25em] text-[#BFA26F] font-semibold mb-6">
            Regional Presence
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 border-t border-l border-[#FBF9F6]/10" data-testid="footer-presence-grid">
            {PRESENCE.map((p) => (
              <div key={p.region} className="border-b border-r border-[#FBF9F6]/10 p-6" data-testid={`footer-region-${p.region.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <h3 className="font-display text-lg font-semibold mb-2">{p.region}</h3>
                <p className="text-xs font-light text-[#FBF9F6]/55 leading-relaxed">{p.note}</p>
              </div>
            ))}
          </div>
          <nav className="mt-10 flex flex-wrap gap-x-7 gap-y-3" data-testid="footer-nav">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-xs uppercase tracking-[0.18em] text-[#FBF9F6]/60 hover:text-[#BFA26F] transition-colors duration-200"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/partner"
              data-testid="footer-link-partner-with-us"
              className="text-xs uppercase tracking-[0.18em] text-[#FBF9F6]/60 hover:text-[#BFA26F] transition-colors duration-200"
            >
              Partner With Us
            </Link>
          </nav>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#FBF9F6]/10 flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          {focus.map((f) => (
            <span key={f} className="text-xs uppercase tracking-[0.2em] text-[#FBF9F6]/50">
              {f}
            </span>
          ))}
        </div>
        <p className="text-xs text-[#FBF9F6]/40 tracking-wide" data-testid="footer-copyright">
          © 2026 RSC Imports — International Sourcing &amp; Market Development. Middle East | India |
          Southeast Asia
        </p>
      </div>
    </div>
  </footer>
);
